<div class="form-holder" id="recap-panel">
  <div class="safe-area">
    <!--
      Recap title + Modify button in case of life vote
    -->
    <!-- <h1 *ngIf=!shouldDisplayLive class="title">{{'POLL-CREATION.CONFIRMATION.RECAP-TITLE' | translate}}</h1> -->
    <div class="live-title">
      <h1 class="title">{{'POLL-CREATION.CONFIRMATION.RECAP-TITLE' | translate}}</h1>
    </div>
    <!--
      Global information about the poll
    -->
    <div class="info-line">
      <img class="item-image" src={{typeImage}}>
      <span class="image-description">{{typeLabel}}</span>
    </div>
    <div class="separator"></div>
    <div class="info-line">
      <img class="item-image" src="assets/title-icon.svg">
      <span class="image-description">{{poll.title}}</span>
    </div>
    <div class="separator"></div>
    <div class="info-parent">
      <div class="info-line-secondary">
        <img class="item-image" src="{{votingTypeIcon}}">
        <span class="image-description">{{questionsLabel}}</span>
      </div>
      <span class="image-description">{{secretLabel}}</span>
    </div>
    <div class="separator"></div>
    <div  *ngIf="(poll.temporality == 'live') && shouldDisplayLive && canBeClosed && isNumbersValid" class="info-parent">
      <div class="info-line-secondary">
        <img class="item-image" src="assets/calendar-simple.svg">
        <span class="image-description">{{'POLL-ONGOING.START' | translate}}</span>
      </div>
      <span class="image-description">{{poll.startDate}}</span>
    </div>
    <div class="separator"  *ngIf="(poll.temporality == 'live') && shouldDisplayLive && canBeClosed && isNumbersValid"></div>
    <div class="info-parent">
      <div class="info-line-secondary">
        <img class="item-image" src="assets/election-simple.svg">
        <span class="image-description">{{votersCountString}} {{'POLL-CREATION.CONFIRMATION.VOTERS' | translate}}</span>
      </div>
      <span *ngIf="!poll.is2FA" class="image-description">{{smsLabel}}</span>
      <span *ngIf="poll.is2FA" class="image-description">{{'POLL-CREATION.CONFIRMATION.2FA' | translate}}</span>
    </div>
    <div class="separator"></div>
    <div *ngIf="poll.isAssessors" class="info-parent">
      <div class="info-line-secondary">
        <img class="item-image" src="assets/election-simple.svg">
        <span class="image-description">{{numberOfAssessors}} {{"ASSESSORS.ASSESSORS-LC" | translate}}</span>
      </div>
    </div>
    <div class="separator" *ngIf="poll.isAssessors"></div>
    <div class="separator" *ngIf="(poll.temporality == 'live') && shouldDisplayLive && canBeClosed && isNumbersValid"></div>
    <div *ngIf="(poll.temporality == 'live') && shouldDisplayLive && canBeClosed && isNumbersValid && (quorum != null)" class="info-parent">
      <div class="info-line-secondary">
        <img class="item-image" style="cursor: pointer;" (click)="displayAttendance()" src="assets/election-simple-selected.svg">
        <span class="image-description">Quorum requis : {{quorum}} <br>Présent(s) : {{attendance}}</span>
      </div>
      <span *ngIf="getQuorum() >= quorum" class="image-description" style="color: green">Atteint</span>
      <span *ngIf="getQuorum() < quorum" class="image-description" style="color: red">Pas atteint</span>
    </div>
    <!--
    <div class="separator" *ngIf="(poll.temporality == 'live') && shouldDisplayLive && canBeClosed && isNumbersValid && (quorum != null)"></div>
    <div class="info-line">
      <img class="item-image" src="assets/euro.svg" style="margin-top: 2.5px;">
      <span class="paid-description">{{priceString}}</span>
    </div>
      Description of the current offer
    <h5 *ngIf="maxVoters > 5" class="image-description">{{paymentString}}</h5>
    <h5 *ngIf="maxVoters <= 5" class="image-description">{{'POLL-CREATION.CONFIRMATION.FREE-DESCRIPTION' | translate}}</h5>
    <h5 *ngIf="maxSMSVoters > 5" class="image-description">{{'POLL-CREATION.CONFIRMATION.SMS-DESCRIPTION' | translate}}
      {{maxSMSVoters.toLocaleString()}}</h5>
    -->
    <!--
      Buttons depending on the poll type and fields filled
    -->
    <div style="height: 24px;"></div>
    <button *ngIf="(poll.temporality !='live' && isPollComplete && isNumbersValid && !editionMode)"
            class="preview-button-disabled" (click)="seePreview()">{{'POLL-CREATION.CONFIRMATION.PREVIEW' | translate}}</button>
    <button *ngIf="!isNumbersValid && maxVoters > 5" class="publish-button"
      (click)="publish(false)">{{'POLL-CREATION.CONFIRMATION.CHANGE-PAYMENT' | translate}}</button>
      <!-- Invalid buttons for live vote before registering emails and after confirming mails -->
      <!-- <button *ngIf="poll.temporality =='live' && !canLaunchLive && !shouldDisplayLive && isNumbersValid"
      class="publish-button-invalid">{{'POLL-CREATION.CONFIRMATION.GO-LIVE' | translate}}</button> -->
    <disabled-button *ngIf="poll.temporality =='live' && !canLaunchLive && !shouldDisplayLive && isNumbersValid"
      [buttonText]="'POLL-CREATION.CONFIRMATION.GO-LIVE' | translate"></disabled-button>
    <div style="text-align: center;">
      <button *ngIf="poll.temporality == 'live'&& shouldDisplayLive && canBeClosed && isNumbersValid" id="button-see-voters" (click)=showVoters()>{{'TIMER.NONVOTERS' | translate}}</button>
    </div>
    <div *ngIf="!sent && poll.temporality == 'live'&& shouldDisplayLive && canBeClosed && isNumbersValid" style="text-align: center;">
      <button class="publish-button" (click)=relaunchVoters()>{{'TIMER.RELAUNCH' | translate}}</button>
    </div>
    <div *ngIf="poll.temporality == 'live'&& shouldDisplayLive && canBeClosed && isNumbersValid" style="text-align: center">
      <p class="description-v" (click)="changeVoters()">{{'POLL-FINISHED.CHANGE-VOTERS' | translate}}</p>
    </div>
    <div *ngIf="sent == true && poll.temporality == 'live'&& shouldDisplayLive && canBeClosed && isNumbersValid" style="text-align: center;">
      <button class="inactive-button" style="width: 100% !important;">{{'TIMER.RELAUNCH' | translate}}</button>
    </div>
    <button *ngIf="(poll.temporality == 'live') && shouldDisplayLive && canBeClosed && isNumbersValid"
            class="red-button" style="width: 100%;" (click)="closeLive()">{{'POLL-CREATION.CONFIRMATION.CLOSE-LIVE' | translate}}</button>
    <button *ngIf="(poll.temporality == 'live') && shouldDisplayLive && canBeClosed && isNumbersValid"
            class="blue-button-bold" style="width: 100%; margin-top: 12px" (click)="viewDraft()">Consulter la configuration du scrutin</button>
      <!-- Invalid button for planned vote when fields aren't filled -->
      <button *ngIf="(poll.temporality != 'live' && !isPollComplete && isNumbersValid)"
      class="publish-button-invalid">{{'POLL-CREATION.CONFIRMATION.LAUNCH-POLL' | translate}}</button>
      <!-- Confirm button on live vote when emails are valid. Display poll creation page -->
    <button *ngIf="poll.temporality == 'live' && canLaunchLive && !shouldDisplayLive && isNumbersValid" class="publish-button"
      (click)="goLive()">{{'POLL-CREATION.CONFIRMATION.GO-LIVE' | translate}}</button>
      <!-- Confirm button for planned poll -->
    <button *ngIf="(poll.temporality !='live' && isPollComplete && isNumbersValid && !editionMode)"
      class="publish-button planned" (click)="publish(false)">{{'POLL-CREATION.CONFIRMATION.LAUNCH-POLL' | translate}}</button>
    <!-- Confirm button for live poll -->

    <button *ngIf="(poll.temporality =='live' && votersCount > 1 && page == 2)"
            class="publish-button planned" (click)="goLive()">{{'POLL-CREATION.CONFIRMATION.GO-LIVE-2' | translate}}</button>
    <button *ngIf="(poll.temporality =='live'&& votersCount < 1 && page == 2)"
            class="publish-button-invalid">{{'POLL-CREATION.CONFIRMATION.GO-LIVE-2' | translate}}</button>
    <button *ngIf="(poll.temporality =='live' && isPollComplete && isNumbersValid && shouldDisplayLive && !canBeClosed && page == 3 && readonlyMode != 1)"
            class="publish-button planned" (click)="publish(true)">{{'POLL-CREATION.CONFIRMATION.VALIDATE-POLL' | translate}}</button>
    <button *ngIf="(poll.temporality =='live' && (!isPollComplete || readonlyMode == 1) && isNumbersValid && shouldDisplayLive && !canBeClosed && page == 3)"
            class="publish-button-invalid">{{'POLL-CREATION.CONFIRMATION.VALIDATE-POLL' | translate}}</button>
    <button *ngIf="(poll.temporality !='live' && isPollComplete && isNumbersValid && editionMode)"
      class="publish-button planned" (click)="sendEdition()">{{'POLL-CREATION.CONFIRMATION.CONFIRM-EDITION' | translate}}</button>
      <!-- Buy an offer button -->
    <button *ngIf="!isNumbersValid && maxVoters <= 5" class="publish-button get-offer"
      (click)="publish(false)">{{'POLL-CREATION.CONFIRMATION.CHOICE-PAYMENT' | translate}}</button>
    <button *ngIf="readonlyMode >= 1" class="publish-button" style="margin-top: 12px" (click)="returnToOrigin()">Revenir au scrutin</button>
  </div>
</div>
